import script from "./MypageSnb.vue?vue&type=script&setup=true&lang=js"
export * from "./MypageSnb.vue?vue&type=script&setup=true&lang=js"

import "./MypageSnb.vue?vue&type=style&index=0&id=a2ecfcfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2ecfcfe"]])

export default __exports__